var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.42857 2 2 6.42857 2 12C2 17.5714 6.42857 22 12 22C17.5714 22 22 17.5714 22 12C22 6.42857 17.5714 2 12 2ZM12 20.5714C7.28571 20.5714 3.42857 16.7143 3.42857 12C3.42857 7.28571 7.28571 3.42857 12 3.42857C16.7143 3.42857 20.5714 7.28571 20.5714 12C20.5714 16.7143 16.7143 20.5714 12 20.5714Z",
    fill: "#2667B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8571 17L12 13.1429L8.14286 17L7 15.8571L10.8571 12L7 8.14286L8.14286 7L12 10.8571L15.8571 7L17 8.14286L13.1429 12L17 15.8571L15.8571 17Z",
    fill: "#2667B0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconBlue);
export default __webpack_public_path__ + "static/media/close_icon_blue.c367167ca415ad5d25bc6cf23dcef658.svg";
export { ForwardRef as ReactComponent };